import { map } from "rxjs/operators";
import { autoBind } from "src/shared/decorators/autobind";
import { HttpClient } from "src/infra/http/client";
import { inject, injectable } from "tsyringe";

import { RequestsEndpoints } from "src/containers/requests/constants/endpoints";
import { CrmRequest } from "src/containers/requests/models/crm-request.model";
import { RequestStatus } from "src/containers/requests/types/request-status";
import { RequestOptions } from "src/infra/http/types";

@injectable()
export class CrmRequestRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getRequests(
        userIdentity: string,
        status: RequestStatus[]
    ): Promise<CrmRequest[]> {
        const options: RequestOptions = {
            isPublicRequest: false,
            host: process.env.REACT_APP_APIMGMT_URL,
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...this.http.httpUtils.getMsBaseHeaders(userIdentity, "MEP"),
            },
        };

        if (status.length > 0) {
            options.params = {
                status: status.join(","),
            };
        }

        return (
            this.http
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .get<Record<string, any>[]>(
                    RequestsEndpoints.CrmRequests,
                    options
                )
                .pipe(
                    map((requests) =>
                        requests.map((req) =>
                            CrmRequest.fromJson<CrmRequest>(req)
                        )
                    )
                )
                .toPromise()
        );
    }
}
